import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import AppLayout from "@/components/AppLayout";
import LoginPage from "@/pages/LoginPage";
import Dashboard from "@/pages/Dashboard";
import ListPage from "@/pages/ListPage";
import OpportunityDossier from "@/pages/OpportunityDossier";
import CandidateReview from "@/pages/CandidateReview";
import TenderDiscoveryControl from "@/pages/TenderDiscoveryControl";
import SearchIntelligenceLibrary from "@/pages/SearchIntelligenceLibrary";
import SearchRuleDetail from "@/pages/SearchRuleDetail";
import Reports from "@/pages/Reports";
import SupplierPortal from "@/pages/SupplierPortal";
import SupplierAssignmentDetail from "@/pages/SupplierAssignmentDetail";
import Settings from "@/pages/Settings";
import { RoleGate } from "@/components/Unauthorized";

const INTERNAL = ["owner","admin","tender_analyst","opportunity_manager","liaison"];
const I = (el) => <RoleGate allow={INTERNAL}>{el}</RoleGate>;
const ANALYST = ["owner","admin","tender_analyst"];
const MGR = ["owner","admin","opportunity_manager","tender_analyst","liaison"];

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<AppLayout />}>
            <Route path="/" element={I(<Dashboard />)} />
            <Route path="/opportunities" element={I(<ListPage collection="opportunities" />)} />
            <Route path="/opportunities/:id" element={I(<OpportunityDossier />)} />
            <Route path="/candidates" element={<RoleGate allow={["owner","admin","tender_analyst","opportunity_manager"]}><ListPage collection="candidate_opportunities" /></RoleGate>} />
            <Route path="/candidates/:id" element={<RoleGate allow={["owner","admin","tender_analyst","opportunity_manager"]}><CandidateReview /></RoleGate>} />
            <Route path="/discovery" element={<RoleGate allow={ANALYST}><TenderDiscoveryControl /></RoleGate>} />
            <Route path="/search-rules" element={<RoleGate allow={ANALYST}><ListPage collection="search_rules" /></RoleGate>} />
            <Route path="/search-rules/:id" element={<RoleGate allow={ANALYST}><SearchRuleDetail /></RoleGate>} />
            <Route path="/search-runs" element={<RoleGate allow={ANALYST}><ListPage collection="search_runs" /></RoleGate>} />
            <Route path="/search-intelligence" element={<RoleGate allow={ANALYST}><SearchIntelligenceLibrary /></RoleGate>} />
            <Route path="/tasks" element={I(<ListPage collection="tasks" />)} />
            <Route path="/documents" element={I(<ListPage collection="documents" />)} />
            <Route path="/buyers" element={I(<ListPage collection="buyers" />)} />
            <Route path="/requirements" element={I(<ListPage collection="requirements" />)} />
            <Route path="/awards" element={I(<ListPage collection="awards" />)} />
            <Route path="/suppliers" element={I(<ListPage collection="suppliers" />)} />
            <Route path="/supplier-assignments" element={I(<ListPage collection="opportunity_suppliers" />)} />
            <Route path="/supplier-samples" element={I(<ListPage collection="supplier_samples" />)} />
            <Route path="/supplier-deliverables" element={I(<ListPage collection="supplier_deliverables" />)} />
            <Route path="/supplier-production" element={I(<ListPage collection="supplier_production" />)} />
            <Route path="/supplier-questions" element={I(<ListPage collection="supplier_questions" />)} />
            <Route path="/reports" element={<RoleGate allow={MGR}><Reports /></RoleGate>} />
            <Route path="/settings" element={I(<Settings />)} />
            <Route path="/supplier" element={<RoleGate allow={["supplier"]}><SupplierPortal /></RoleGate>} />
            <Route path="/supplier/assignments/:id" element={<RoleGate allow={["supplier"]}><SupplierAssignmentDetail /></RoleGate>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
